// services/sugerirSchemas.js
// Usa os teus arquivos existentes:
import nomesBonitosCategoria from "../utils/nomesBonitosCategoria";
import { categoriasPorModo } from "./estruturaCategorias";

/**
 * Campos exigidos por categoria na hora de sugerir.
 * Formatos:
 *  - "titulodofilme"
 *  - "titulodofilme+pais"
 *  - "titulodacanção+filme"
 *  - "nomedoprofissional+filme"
 */
export const camposPorCategoria = {
  // Filme + país
  melhorfilmeinternacional: "titulodofilme+pais",
  melhorfilmeemlinguanaoinglesa: "titulodofilme+pais",

  // Canção + filme
  melhorcancaooriginal: "titulodacanção+filme",
  melhorcancao: "titulodacanção+filme",

  // Profissional + filme (atuações/direção)
  melhordirecao: "nomedoprofissional+filme",
  melhorator: "nomedoprofissional+filme",
  melhoratriz: "nomedoprofissional+filme",
  melhoratorcoadjuvante: "nomedoprofissional+filme",
  melhoratrizcoadjuvante: "nomedoprofissional+filme",
  melhoratoremdrama: "nomedoprofissional+filme",
  melhoratrizemdrama: "nomedoprofissional+filme",
  melhoratoremcomediaoumusical: "nomedoprofissional+filme",
  melhoratrizemcomediaoumusical: "nomedoprofissional+filme",
  melhoratoratrizemascensao: "nomedoprofissional+filme",
  melhorjovematoratriz: "nomedoprofissional+filme",
};

// Qualquer categoria não listada acima cai no padrão "titulodofilme"
export function getCamposParaCategoria(categoriaId) {
  return camposPorCategoria[categoriaId] || "titulodofilme";
}

/**
 * Mapeia categoria -> tipo lógico, para salvar no Firestore em `tipoCategoria`
 *  - "filme" | "atuacao" | "internacional" | "musica" | "outro"
 */
export function getTipoCategoria(categoriaId) {
  if (categoriaId === "melhorfilmeinternacional" || categoriaId === "melhorfilmeemlinguanaoinglesa") {
    return "internacional";
  }
  if (categoriaId === "melhorcancaooriginal" || categoriaId === "melhorcancao") {
    return "musica";
  }
  if (
    [
      "melhordirecao",
      "melhorator", "melhoratriz",
      "melhoratorcoadjuvante", "melhoratrizcoadjuvante",
      "melhoratoremdrama", "melhoratrizemdrama",
      "melhoratoremcomediaoumusical", "melhoratrizemcomediaoumusical",
      "melhoratoratrizemascensao", "melhorjovematoratriz",
    ].includes(categoriaId)
  ) {
    return "atuacao";
  }
  if (categoriaId === "melhorfilme") return "filme";
  return "outro";
}

/** Nome bonito (usa teu dicionário) */
export function getNomeBonito(categoriaId) {
  return nomesBonitosCategoria[categoriaId] || categoriaId;
}

/** Ordem correta das categorias por modo (usa teu arquivo) */
export function getCategoriasOrdenadasDoModo(modoId) {
  return categoriasPorModo[modoId] || [];
}
